// extracted by mini-css-extract-plugin
export default {"iconWrapper":"IconWrapper_iconWrapper__uzs3M"};